export const ROLE_TO_REPORT_TYPE_MAPPING = {
  SeniorPastor: 'SENIOR_PASTOR',
  Evangelist: 'EVANGELIST'
};

export const ROLE_TO_TITLE_ROLE_MAPPING = {
  SeniorPastor: 'PASTOR',
  Evangelist: 'EVANGELIST'
};

export const MINIMUM_PUBLISHED_PHASE = 3;

export const MISSING_REPORT_TEXT = 'Report will be published soon';



// WEBPACK FOOTER //
// ./src/components/pages/successReports/constants.js